import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

// Layout & Auth
import Sidebar from "./Components/Sidebar/Sidebar";
import Login from "./Components/Login/Login";
import Dashboard from "./Components/Dashboard/Dashboard";
import PrivateRoutes from "./Components/services/ProtectedRoute";
import { AuthProvider, useAuth } from "./Components/services/AuthContext";

// ========== MASTERS - STAFF ==========
import StaffTable from "./Components/Masters/Staff/StaffTable";
import StaffCreate from "./Components/Masters/Staff/Create";
import StaffEdit from "./Components/Masters/Staff/Edit";
import StaffView from "./Components/Masters/Staff/View";

// ========== MASTERS - BRAND ==========
import BrandTable from "./Components/Masters/Brand/BrandTable";
import BrandCreate from "./Components/Masters/Brand/Create";
import BrandEdit from "./Components/Masters/Brand/Edit";
import BrandView from "./Components/Masters/Brand/View";

// ========== MASTERS - PRODUCT ==========
import ProductTable from "./Components/Masters/Product/ProductTable";
import ProductCreate from "./Components/Masters/Product/Create";
import ProductEdit from "./Components/Masters/Product/Edit";
import ProductView from "./Components/Masters/Product/View";

// ========== MASTERS - WAREHOUSE ==========
import WarehouseTable from "./Components/Masters/Warehouse/WarehouseTable";
import WarehouseCreate from "./Components/Masters/Warehouse/Create";
import WarehouseEdit from "./Components/Masters/Warehouse/Edit";
import WarehouseView from "./Components/Masters/Warehouse/View";

// ========== MASTERS - CUSTOMER ==========
import CustomerTable from "./Components/Masters/Customer/CustomerTable";
import CustomerCreate from "./Components/Masters/Customer/Create";
import CustomerEdit from "./Components/Masters/Customer/Edit";
import CustomerView from "./Components/Masters/Customer/View";

// ========== MASTERS - SUPPLIER ==========
import SupplierTable from "./Components/Masters/Supplier/SupplierTable";
import SupplierCreate from "./Components/Masters/Supplier/Create";
import SupplierEdit from "./Components/Masters/Supplier/Edit";
import SupplierView from "./Components/Masters/Supplier/View";

// ========== MASTERS - BRANCH ==========
import BranchTable from "./Components/Masters/Branch/BranchTable";
import BranchCreate from "./Components/Masters/Branch/Create";
import BranchEdit from "./Components/Masters/Branch/Edit";
import BranchView from "./Components/Masters/Branch/View";

// ========== MASTERS - GROUP ==========
import GroupTable from "./Components/Grouping/Group/GroupTable";
import GroupCreate from "./Components/Grouping/Group/Create";
import GroupEdit from "./Components/Grouping/Group/Edit";
import GroupView from "./Components/Grouping/Group/View";

// ========== MASTERS - DEPARTMENT ==========
import DepartmentTable from "./Components/Masters/Department/DepartmentTable";

// ========== MASTERS - COMPANY ==========
import CompanyEdit from "./Components/Masters/Company/Company";
import CompanyView from "./Components/Masters/Company/View";

// ========== MASTERS - IMAGE/DRAWING ==========
import ImageTable from "./Components/Image/ImageTable";
import ImageUpload from "./Components/Image/ImageUpload";
import ImageView from "./Components/Image/ImageView";

// ========== MASTERS - CONTACTS ==========
import ContactTable from "./Components/Masters/Customer/ContactTable";
import ContactCreate from "./Components/Masters/Customer/AddContact";
import ContactView from "./Components/Masters/Customer/ViewContact";
import ContactEdit from "./Components/Masters/Customer/EditContact";
import ContactSTable from "./Components/Masters/Supplier/ContactStable";
import ContactSCreate from "./Components/Masters/Supplier/AddContact";
import ContactSView from "./Components/Masters/Supplier/ViewContact";
import ContactSEdit from "./Components/Masters/Supplier/EditContact";

// ========== PURCHASE MODULE ==========
// Purchase Enquiry
import PoEnquiryTable from "./Components/Purchses/PoEnquiry/PoEnquiryTable";
import PoEnquiryCreate from "./Components/Purchses/PoEnquiry/Create";
import PoEnquiryEdit from "./Components/Purchses/PoEnquiry/Edit";
import PoEnquiryView from "./Components/Purchses/PoEnquiry/View";

// Purchase Order
import PoTable from "./Components/Purchses/PurchaseOrder/PoTable";
import PoCreate from "./Components/Purchses/PurchaseOrder/Create";
import PoEdit from "./Components/Purchses/PurchaseOrder/Edit";
import PoView from "./Components/Purchses/PurchaseOrder/View";

// MRN / GRN
import MRNTable from "./Components/Purchses/MRN/MRNTable";
import MRNCreate from "./Components/Purchses/MRN/Create";
import MRNEdit from "./Components/Purchses/MRN/Edit";
import MRNView from "./Components/Purchses/MRN/View";

// Inspection
import InspectionTable from "./Components/Purchses/Inspection/InspectionTable";
import InspectionCreate from "./Components/Purchses/Inspection/Create";
import InspectionEdit from "./Components/Purchses/Inspection/Edit";
import InspectionView from "./Components/Purchses/Inspection/View";

// Purchase
import PTable from "./Components/Purchses/Purchase/Table";
import PCreate from "./Components/Purchses/Purchase/Create";
import PEdit from "./Components/Purchses/Purchase/Edit";
import PView from "./Components/Purchses/Purchase/View";

// Purchase Return
import PRTable from "./Components/Purchses/PurchaseReturn/Table";
import PRCreate from "./Components/Purchses/PurchaseReturn/Create";
import PRView from "./Components/Purchses/PurchaseReturn/View";

// ========== SALES MODULE ==========
// Sales Enquiry (CRM)
import SalesEnquiryTable from "./Components/CRM/Enquiry/SalesEnquiry/SalesEnquiryIndexTable";
import SalesEnquiryCreate from "./Components/CRM/Enquiry/SalesEnquiry/CreateSalesEnquiry";
import SalesEnquiryEdit from "./Components/CRM/Enquiry/SalesEnquiry/EditSalesEnquiry";
import SalesEnquiryView from "./Components/CRM/Enquiry/SalesEnquiry/ViewSalesEnquiry";

// Quotation (CRM)
import QuotationTable from "./Components/CRM/SOQuotation/SOQuotationIndexTable";
import QuotationCreate from "./Components/CRM/SOQuotation/CreateSOQuotation";
import QuotationEdit from "./Components/CRM/SOQuotation/EditSoQuotation";
import QuotationView from "./Components/CRM/SOQuotation/ViewSoQuotation";

// Sales Order
import SalesOrderTable from "./Components/Saless/SalesOrder/SalesOrderIndexTable";
import SalesOrderCreate from "./Components/Saless/SalesOrder/CreateSalesOrder";
import SalesOrderEdit from "./Components/Saless/SalesOrder/EditSalesOrder";
import SalesOrderView from "./Components/Saless/SalesOrder/ViewSalesOrder";

// Delivery Challan
import DcTable from "./Components/Saless/DC/DCTable";
import DcCreate from "./Components/Saless/DC/Create";
import DcEdit from "./Components/Saless/DC/Edit";
import DcView from "./Components/Saless/DC/View";

// Sales Invoice
import SalesTable from "./Components/Saless/Sales/SalesTable";
import SalesCreate from "./Components/Saless/Sales/Create";
import SalesEdit from "./Components/Saless/Sales/Edit";
import SalesView from "./Components/Saless/Sales/View";

// Sales Return
import SrTable from "./Components/Saless/SalesReturn/SalesTable";
import SrCreate from "./Components/Saless/SalesReturn/Create";
import SrView from "./Components/Saless/SalesReturn/View";

// ========== PRODUCTION MODULE ==========
// BOM
import BomTable from "./Components/Production/BOM/BomTable";
import BomCreate from "./Components/Production/BOM/Create";
import BomEdit from "./Components/Production/BOM/Edit";
import BomView from "./Components/Production/BOM/View";

// Production Order
import ProductionOrderTable from "./Components/Production/ProductionOrder/Table";
import ProductionOrderCreate from "./Components/Production/ProductionOrder/Create";
import ProductionOrderEdit from "./Components/Production/ProductionOrder/Edit";
import ProductionOrderView from "./Components/Production/ProductionOrder/View";

// Issue Slip
import IssueSlipTable from "./Components/Production/IssueSlip/Table";
import IssueSlipCreate from "./Components/Production/IssueSlip/Create";
import IssueSlipEdit from "./Components/Production/IssueSlip/Edit";
import IssueSlipView from "./Components/Production/IssueSlip/View";

// Production Process
import ProcessTable from "./Components/Production/Pump-production-process/Table";
import ProcessCreate from "./Components/Production/Pump-production-process/Create";
import ProcessEdit from "./Components/Production/Pump-production-process/Edit";
import ProcessView from "./Components/Production/Pump-production-process/View";

// ========== INVENTORY MODULE ==========
// Stock Reports
import StockReportQuantity from "./Components/Inventory/StockDetailsReports";
import StockReportValue from "./Components/Inventory/StockDetailsReportsValue";
import StockDetailsQuantity from "./Components/Inventory/ProductStockDetails";
import StockDetailsValue from "./Components/Inventory/ProductStockDetailsValue";

// Opening Stock
import OpeningStockTable from "./Components/Inventory/OpeningStock/Table";
import OpeningStockCreate from "./Components/Inventory/OpeningStock/Create";
import OpeningStockEdit from "./Components/Inventory/OpeningStock/Update";
import OpeningStockView from "./Components/Inventory/OpeningStock/View";

// ========== CONVERSION ROUTES ==========
import SoToDcConvert from "./Components/Saless/DC/SoToDcConvert/Create";
import DcToSalesConvert from "./Components/Saless/Sales/DcToSales/Convert";
import SoToSalesConvert from "./Components/Saless/Sales/DcToSales/IConvert";
import SeToSqConversion from "./Components/CRM/SOQuotation/SEtoSQConversion";
import SqToSoConversion from "./Components/Saless/SalesOrder/SQtoSOConversion";
import SToSrConvert from "./Components/Saless/SalesReturn/SalesToSalesReturn/Convert";
import PurchaseToPRConvert from "./Components/Purchses/PurchaseReturn/PuechaseToPR/PurchaseToPurchaseReturn";
import PeToPoConvert from "./Components/Purchses/PurchaseOrder/PeToPo/PurchaseToPurchaseReturn";
import PoToMrnConvert from "./Components/Purchses/MRN/PoToMrn/Convert";
import MrnToInspectionConvert from "./Components/Purchses/Inspection/MrnToInspection/Convert";
import PoToPConvert from "./Components/Purchses/Purchase/PoToP/Convert";
import InspectionToPurchaseConvert from "./Components/Purchses/Purchase/InspectionToPurchase/Convert";
import PoToGrnConvert from "./Components/Purchses/MRN/PoToGrnConvert/Convert";

// ========== PRINT ROUTES ==========
import SalesInvoicePumpDomesticPrint from "./Components/Saless/Sales/PumpSpareDomestic/SalesInvoicePumpDomesticPrint";
import SalesInvoiceInternationalPrint from "./Components/Saless/Sales/PumpSpareInternational/PrintPSI";
import SalesInvoiceManufacturingInternationalPrint from "./Components/Saless/Sales/AraiManufacturing/PrintAMI";
import SalesInvoiceManufacturingDomesticPrint from "./Components/Saless/Sales/ManufacturingDomestic/SalesInvoiceManufacturingDomesticPrint";
import PoDomPrint from "./Components/Purchses/PurchaseOrder/AraiManufacturing/PoDomPrint";
import PiDuplicate from "./Components/Purchses/PoEnquiry/PumpSpareInternational/PIDuplicate";
import AraiMDuplicate from "./Components/Purchses/PoEnquiry/AraiManufacturing/AraiMDuplicate";
import AraiManufacturingDomesticSQPrint from "./Components/CRM/SOQuotation/AraiMfgDomesticSQ/AraiManufacturingDomesticSalesQuotationPrint";
import PumpAraiDomesticSQPrint from "./Components/CRM/SOQuotation/PumpDomesticQuotation/PumpAraiDomesticSalesQuotationPrint";
import PumpAraiInternationalSQPrint from "./Components/CRM/SOQuotation/PumpInternationalQuotation/PumpAraiInternationalSalesQuotationPrint";

function AppContent() {
  const { user, isAuthenticated, logout } = useAuth();

  return (
    <div className="app-container">
      {isAuthenticated ? (
        <Sidebar onLogout={logout} user={user}>
          <Routes>
            <Route element={<PrivateRoutes />}>
              {/* Dashboard */}
              <Route path="/home" element={<Dashboard />} />
              <Route path="/" element={<Navigate to="/home" replace />} />

              {/* ========== MASTERS ROUTES ========== */}
              {/* Staff */}
              <Route path="/staffindex/:pointindex" element={<StaffTable />} />
              <Route path="/staffCreate" element={<StaffCreate />} />
              <Route path="/staffEdit/:id/:pointindex" element={<StaffEdit />} />
              <Route path="/staffView/:id/:pointindex" element={<StaffView />} />

              {/* Brand */}
              <Route path="/brandindex/:pointindex" element={<BrandTable />} />
              <Route path="/brandCreate" element={<BrandCreate />} />
              <Route path="/brandEdit/:id/:pointindex" element={<BrandEdit />} />
              <Route path="/brandView/:id/:pointindex" element={<BrandView />} />

              {/* Product */}
              <Route path="/productindex/:pointindex" element={<ProductTable />} />
              <Route path="/productCreate" element={<ProductCreate />} />
              <Route path="/productEdit/:id/:pointindex" element={<ProductEdit />} />
              <Route path="/productView/:id/:pointindex" element={<ProductView />} />

              {/* Warehouse */}
              <Route path="/warehouseindex/:pointindex" element={<WarehouseTable />} />
              <Route path="/warehouseCreate" element={<WarehouseCreate />} />
              <Route path="/warehouseEdit/:id/:pointindex" element={<WarehouseEdit />} />
              <Route path="/warehouseView/:id/:pointindex" element={<WarehouseView />} />

              {/* Customer */}
              <Route path="/customerindex/:pointindex" element={<CustomerTable />} />
              <Route path="/customerCreate" element={<CustomerCreate />} />
              <Route path="/customerEdit/:id/:pointindex" element={<CustomerEdit />} />
              <Route path="/customerView/:id/:pointindex" element={<CustomerView />} />

              {/* Supplier */}
              <Route path="/supplierindex/:pointindex" element={<SupplierTable />} />
              <Route path="/supplierCreate" element={<SupplierCreate />} />
              <Route path="/supplierEdit/:id/:pointindex" element={<SupplierEdit />} />
              <Route path="/supplierView/:id/:pointindex" element={<SupplierView />} />

              {/* Branch */}
              <Route path="/branchindex/:pointindex" element={<BranchTable />} />
              <Route path="/branchCreate" element={<BranchCreate />} />
              <Route path="/branchEdit/:id/:pointindex" element={<BranchEdit />} />
              <Route path="/branchView/:id/:pointindex" element={<BranchView />} />

              {/* Group */}
              <Route path="/groupindex/:pointindex" element={<GroupTable />} />
              <Route path="/groupCreate" element={<GroupCreate />} />
              <Route path="/groupEdit/:id/:pointindex" element={<GroupEdit />} />
              <Route path="/groupView/:id/:pointindex" element={<GroupView />} />

              {/* Department */}
              <Route path="/department-list/:pointindex" element={<DepartmentTable />} />
              {/* Company */}
              <Route path="/company" element={<CompanyView />} />
              <Route path="/company/edit" element={<CompanyEdit />} />

              {/* Image/Drawing */}
              <Route path="/imagetabledindex/:pointindex" element={<ImageTable />} />
              <Route path="/imageupload" element={<ImageUpload />} />
              <Route path="/imageView/:id/:pointindex" element={<ImageView />} />

              {/* Contacts - Customer */}
              <Route path="/contactTable/:id/:pointindex" element={<ContactTable />} />
              <Route path="/contactCreate/:id" element={<ContactCreate />} />
              <Route path="/contactView/:id/:id2/:pointindex" element={<ContactView />} />
              <Route path="/contactEdit/:id/:id2/:pointindex" element={<ContactEdit />} />

              {/* Contacts - Supplier */}
              <Route path="/contactSTable/:id/:pointindex" element={<ContactSTable />} />
              <Route path="/contactSCreate/:id" element={<ContactSCreate />} />
              <Route path="/contactSView/:id/:id2/:pointindex" element={<ContactSView />} />
              <Route path="/contactSEdit/:id/:id2/:pointindex" element={<ContactSEdit />} />

              {/* ========== PURCHASE ROUTES ========== */}
              {/* Purchase Enquiry */}
              <Route path="/poenquiryindex/:pointindex" element={<PoEnquiryTable />} />
              <Route path="/poenquiryindex/create" element={<PoEnquiryCreate />} />
              <Route path="/poenquiryEdit/:id/:pointindex" element={<PoEnquiryEdit />} />
              <Route path="/poenquiryView/:id/:pointindex" element={<PoEnquiryView />} />

              {/* Purchase Order */}
              <Route path="/poindex/:pointindex" element={<PoTable />} />
              <Route path="/poCreate" element={<PoCreate />} />
              <Route path="/poEdit/:id/:pointindex" element={<PoEdit />} />
              <Route path="/poView/:id/:pointindex" element={<PoView />} />

              {/* MRN / GRN */}
              <Route path="/mrnindex/:pointindex" element={<MRNTable />} />
              <Route path="/mrnCreate" element={<MRNCreate />} />
              <Route path="/mrnEdit/:id/:pointindex" element={<MRNEdit />} />
              <Route path="/mrnView/:id/:pointindex" element={<MRNView />} />

              {/* Inspection */}
              <Route path="/irindex/:pointindex" element={<InspectionTable />} />
              <Route path="/irCreate" element={<InspectionCreate />} />
              <Route path="/irEdit/:id/:pointindex" element={<InspectionEdit />} />
              <Route path="/irView/:id/:pointindex" element={<InspectionView />} />

              {/* Purchase */}
              <Route path="/pindex/:pointindex" element={<PTable />} />
              <Route path="/pCreate" element={<PCreate />} />
              <Route path="/pEdit/:id/:pointindex" element={<PEdit />} />
              <Route path="/pView/:id/:pointindex" element={<PView />} />

              {/* Purchase Return */}
              <Route path="/prindex/:pointindex" element={<PRTable />} />
              <Route path="/prCreate" element={<PRCreate />} />
              <Route path="/prView/:id/:pointindex" element={<PRView />} />

              {/* ========== SALES / CRM ROUTES ========== */}
              {/* Sales Enquiry */}
              <Route path="/salesEnquiryIndex/:pointindex" element={<SalesEnquiryTable />} />
              <Route path="/createSalesEnquiry" element={<SalesEnquiryCreate />} />
              <Route path="/editSalesEnquiry/:id/:pointindex" element={<SalesEnquiryEdit />} />
              <Route path="/viewSalesEnquiry/:id/:pointindex" element={<SalesEnquiryView />} />

              {/* Quotation */}
              <Route path="/quotationIndexTable/:pointindex" element={<QuotationTable />} />
              <Route path="/createQuotation" element={<QuotationCreate />} />
              <Route path="/editQuotation/:id/:pointindex" element={<QuotationEdit />} />
              <Route path="/viewQuotation/:id/:pointindex" element={<QuotationView />} />

              {/* Sales Order */}
              <Route path="/salesOrderIndexTable/:pointindex" element={<SalesOrderTable />} />
              <Route path="/createSalesOrder" element={<SalesOrderCreate />} />
              <Route path="/editSalesOrder/:id/:pointindex" element={<SalesOrderEdit />} />
              <Route path="/viewSalesOrder/:id/:pointindex" element={<SalesOrderView />} />

              {/* Delivery Challan */}
              <Route path="/dcindex/:pointindex" element={<DcTable />} />
              <Route path="/dcCreate" element={<DcCreate />} />
              <Route path="/dcEdit/:id/:pointindex" element={<DcEdit />} />
              <Route path="/dcView/:id/:pointindex" element={<DcView />} />

              {/* Sales Invoice */}
              <Route path="/salesindex/:pointindex" element={<SalesTable />} />
              <Route path="/salesCreate" element={<SalesCreate />} />
              <Route path="/salesEdit/:id/:pointindex" element={<SalesEdit />} />
              <Route path="/salesView/:id/:pointindex" element={<SalesView />} />

              {/* Sales Return */}
              <Route path="/srindex/:pointindex" element={<SrTable />} />
              <Route path="/srCreate" element={<SrCreate />} />
              <Route path="/srView/:id/:pointindex" element={<SrView />} />

              {/* ========== PRODUCTION ROUTES ========== */}
              {/* BOM */}
              <Route path="/bomindex/:pointindex" element={<BomTable />} />
              <Route path="/BOMCreate" element={<BomCreate />} />
              <Route path="/BOMEdit/:id/:pointindex" element={<BomEdit />} />
              <Route path="/BOMView/:id/:pointindex" element={<BomView />} />

              {/* Production Order */}
              <Route path="/Porderindex/:pointindex" element={<ProductionOrderTable />} />
              <Route path="/PorderCreate" element={<ProductionOrderCreate />} />
              <Route path="/PorderUpdate/:id/:pointindex" element={<ProductionOrderEdit />} />
              <Route path="/PorderView/:id/:pointindex" element={<ProductionOrderView />} />

              {/* Issue Slip */}
              <Route path="/issue-slip-list/:pointindex" element={<IssueSlipTable />} />
              <Route path="/IssueSlipCreate" element={<IssueSlipCreate />} />
              <Route path="/IssueSlipUpdate/:id/:pointindex" element={<IssueSlipEdit />} />
              <Route path="/IssueSlipView/:id/:pointindex" element={<IssueSlipView />} />

              {/* Production Process */}
              <Route path="/pump-production-process-list/:pointindex" element={<ProcessTable />} />
              <Route path="/pump-production-process-add" element={<ProcessCreate />} />
              <Route path="/pump-production-process-update/:id/:pointindex" element={<ProcessEdit />} />
              <Route path="/pump-production-process-view/:id/:pointindex" element={<ProcessView />} />

              {/* ========== INVENTORY ROUTES ========== */}
              {/* Stock Reports */}
              <Route path="/stock-report-quantity" element={<StockReportQuantity />} />
              <Route path="/stock-report-value" element={<StockReportValue />} />
              <Route path="/stock-details-quantity" element={<StockDetailsQuantity />} />
              <Route path="/stock-details-value" element={<StockDetailsValue />} />

              {/* Opening Stock */}
              <Route path="/opening-stock-list/:pointindex" element={<OpeningStockTable />} />
              <Route path="/opening-stock-add" element={<OpeningStockCreate />} />
              <Route path="/opening-stock-update/:id/:pointindex" element={<OpeningStockEdit />} />
              <Route path="/opening-stock-view/:id/:pointindex" element={<OpeningStockView />} />

              {/* ========== CONVERSION ROUTES ========== */}
              <Route path="/sotodcconvert/:id" element={<SoToDcConvert />} />
              <Route path="/dctosalesconvert/:id" element={<DcToSalesConvert />} />
              <Route path="/sotosalesconvert/:id" element={<SoToSalesConvert />} />
              <Route path="/stosrconvert/:id" element={<SToSrConvert />} />
              <Route path="/setosqconversion/:id" element={<SeToSqConversion />} />
              <Route path="/sqtosoconversion/:id" element={<SqToSoConversion />} />
              <Route path="/ptoprconvert/:id" element={<PurchaseToPRConvert />} />
              <Route path="/petopoconvert/:id" element={<PeToPoConvert />} />
              <Route path="/inspection-to-grn-convert/:id" element={<PoToMrnConvert />} />
              <Route path="/purchase-order-to-inspection-convert/:id" element={<MrnToInspectionConvert />} />
              <Route path="/purchase-order-to-grn-convert/:id" element={<PoToGrnConvert />} />
              <Route path="/grn-to-purchase-convert/:id" element={<PoToPConvert />} />
              <Route path="/itopconvert/:id" element={<InspectionToPurchaseConvert />} />

              {/* ========== PRINT ROUTES ========== */}
              <Route path="/salesInvoice/print/:id" element={<SalesInvoicePumpDomesticPrint />} />
              <Route path="/salesInvoiceInternational/print/:id" element={<SalesInvoiceInternationalPrint />} />
              <Route path="/salesInvoiceManufacturingInternational/print/:id" element={<SalesInvoiceManufacturingInternationalPrint />} />
              <Route path="/Sales-Invoice-Manufacturing-Domestic/print/:id" element={<SalesInvoiceManufacturingDomesticPrint />} />
              <Route path="/Purchses/PurchaseOrder/AraiManufacturing/PoDomPrint/:id" element={<PoDomPrint />} />
              <Route path="/piduplicate/:id" element={<PiDuplicate />} />
              <Route path="/araimduplicate/:id" element={<AraiMDuplicate />} />
              <Route path="/CRM/SOQuotation/AraiManufacturingDomesticSalesQuotationPrint/:id" element={<AraiManufacturingDomesticSQPrint />} />
              <Route path="/CRM/SOQuotation/PumpDomesticQuotation/PumpAraiDomesticSalesQuotationPrint/:id" element={<PumpAraiDomesticSQPrint />} />
              <Route path="/CRM/SOQuotation/PumpInternationalQuotation/PumpAraiInternationalSalesQuotationPrint/:id" element={<PumpAraiInternationalSQPrint />} />
            </Route>

            {/* Catch all - redirect to home */}
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </Sidebar>
      ) : (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;